export type ThumbnailArea = {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
};

/** Full-frame crop in normalized 0–1 coordinates (stable reference for forms). */
export const DEFAULT_THUMBNAIL_AREA: ThumbnailArea = { x1: 0, y1: 0, x2: 1, y2: 1 };
